import { ApprovalI, approvalsTypes } from "../approvals/approvalsTypes";
import { realTimeData } from "../realTimeData/types";
import { ApprovalDetailsStateI, SetApprovalI, approvalDetailsTypes } from "./approvalDetailsTypes";

export const initialState: ApprovalDetailsStateI = {};

const ACTION_REDUCER = {
  [approvalDetailsTypes.SET_APPROVAL]: (
    state: ApprovalDetailsStateI,
    { payload: approval, index, detailsType }: SetApprovalI,
  ) => ({
    ...state,
    approval,
    index,
    detailsType,
  }),
  [approvalsTypes.UPDATE_OFFER_QUEUE_SUCCESS]: (state: ApprovalDetailsStateI, { payload }: { payload: ApprovalI }) => {
    const updatedApprovalIsOpened = state.approval?.approval_id === payload.approval_id;

    return {
      ...state,
      approval: updatedApprovalIsOpened ? payload : state.approval,
    };
  },
  [realTimeData.REMOVE_STACK]: (
    state: ApprovalDetailsStateI,
    { payload }: { payload: { approval: { approval_id: number } } },
  ) => {
    const deletedApprovalIsOpened = state.approval?.approval_id === payload?.approval?.approval_id;

    return deletedApprovalIsOpened ?
      {} :
      {
        ...state,
      };
  },
};

const reducer = (state: ApprovalDetailsStateI = initialState, action: any) => {
  const actionReducer = ACTION_REDUCER[action.type];
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore

  return actionReducer ? actionReducer(state, action) : state;
};

export default reducer;
